import { fetcher } from 'services/helpers/responseHandler'

const getPendingChatCount = async () => fetcher.get('chat/list/pending/count')

const getEmail = async ({ chatId, providerMessageId }) =>
  fetcher.get('chat/retrieve/email', { chatId, providerMessageId })

const messagingApi = {
  getPendingChatCount,
  getEmail
}

export default messagingApi
